function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import * as radio from "@zag-js/radio-group";
import { twMerge } from "@stereoagency/tailwind-config";
import { normalizeProps, useMachine } from "@zag-js/react";
import React, { useId } from "react";
export var DonationPeriod;
(function(DonationPeriod) {
    DonationPeriod["ONE_TIME"] = "one_time";
    DonationPeriod["MONTHLY"] = "monthly";
})(DonationPeriod || (DonationPeriod = {}));
export default function DonationPeriodSwitch(param) {
    var options = param.options, initialValue = param.initialValue, onChange = param.onChange, className = param.className;
    var id = useId();
    var controlId = "donation-period-switch-".concat(id);
    var _useMachine = _sliced_to_array(useMachine(radio.machine({
        id: controlId,
        value: initialValue,
        onValueChange: function onValueChange(details) {
            onChange === null || onChange === void 0 ? void 0 : onChange(details.value);
        }
    })), 2), state = _useMachine[0], send = _useMachine[1];
    var api = radio.connect(state, send, normalizeProps);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({}, api.rootProps), {
        style: {
            "--grid-cols-count": options.length
        },
        className: twMerge("grid grid-cols-[repeat(var(--grid-cols-count),1fr)] rounded-full outline outline-4 outline-transparent", "transition-all delay-75 duration-200 focus-within:outline-black/50", className)
    }), options.map(function(opt) {
        return /*#__PURE__*/ React.createElement("label", _object_spread({
            key: opt.value,
            htmlFor: "".concat(controlId, "-").concat(opt.value),
            className: twMerge("bg-black/20 p-4 text-center text-fg-inverted first-of-type:rounded-l-full last-of-type:rounded-r-full", "[&[data-state=checked]]:bg-fg-inverted [&[data-state=checked]]:text-fg-base")
        }, api.getItemProps({
            value: opt.value
        })), /*#__PURE__*/ React.createElement("span", _object_spread_props(_object_spread({}, api.getItemTextProps({
            value: opt.value
        })), {
            className: "text-navigation-base font-semibold font-heading"
        }), opt.label), /*#__PURE__*/ React.createElement("input", _object_spread({
            id: "".concat(controlId, "-").concat(opt.value)
        }, api.getItemHiddenInputProps({
            value: opt.value
        }))));
    }));
}

//# sourceMappingURL=DonationPeriodSwitch.js.map